<template>
  <div>
    <v-card-title class="headline primary" primary-title dark>
      {{ alertTitle }}
    </v-card-title>

    <v-card-text>
      {{ alertMessage }}
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="$emit('confirm')">
        {{ $t('button.ok') }}
      </v-btn>
      <v-btn text @click="$emit('cancel')">
        {{ $t('button.cancel') }}
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
export default {
  props: {
    alertTitle: {
      type: String,
      required: true,
    },
    alertMessage: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.v-card__title {
  color: white;
}
</style>
